import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { api, formatApiError } from "@/lib/api";
import { fmtDateTime } from "@/lib/constants";

export const LegacyNotifications = () => {
  const [items, setItems] = useState([]);
  const [sel, setSel] = useState([]);
  const load = () => api.get("/notifications/legacy").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  if (!items.length) return null;
  const toggle = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  const act = async (path, ok) => {
    try {
      await api.post(path, { ids: sel });
      toast.success(ok);
      setSel([]);
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  return (
    <section className="dt-card max-w-3xl space-y-3 p-6" data-testid="legacy-notifications">
      <h2 className="font-display text-lg font-semibold text-white">Confirmations pour les interventions déjà planifiées</h2>
      <p className="text-sm text-slate-400">Aucune confirmation n'est envoyée automatiquement pour ces interventions existantes. Sélectionnez celles à confirmer.</p>
      <ul className="space-y-1">
        {items.map((i) => (
          <li key={i.id} className="flex items-center gap-3 text-sm text-slate-200">
            <Checkbox checked={sel.includes(i.id)} onCheckedChange={() => toggle(i.id)} disabled={!i.client_email} data-testid={`legacy-select-${i.id}`} />
            <span>{fmtDateTime(i.scheduled_at)} — {i.title} · {i.client_name} {i.client_email ? `(${i.client_email})` : "(pas d'e-mail)"}</span>
          </li>
        ))}
      </ul>
      <div className="flex gap-2">
        <Button onClick={() => act("/notifications/legacy/send", "Confirmations transmises")} disabled={!sel.length} className="dt-glow" data-testid="legacy-send-button">Envoyer les confirmations sélectionnées</Button>
        <Button variant="ghost" onClick={() => act("/notifications/legacy/dismiss", "Retirées de la liste")} disabled={!sel.length} data-testid="legacy-dismiss-button">Ne pas notifier</Button>
      </div>
    </section>
  );
};
